import { pxToRem, responsiveFontSizes } from './responsiveFontSizes';

const FONT_PRIMARY = 'Inter, sans-serif';
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    text1: true;
    text2: true;
    text3: true;
    h6: false;
    subtitle1: false;
    subtitle2: false;
    body1: false;
    body2: false;
    caption: false;
    overline: false;
    inherit: false;
    button: false;
  }
}
declare module '@mui/material/styles' {
  interface TypographyVariants {
    text1: React.CSSProperties;
    text2: React.CSSProperties;
    text3: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    text1?: React.CSSProperties;
    text2?: React.CSSProperties;
    text3?: React.CSSProperties;
  }
}

export const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  h1: {
    fontWeight: 600,
    lineHeight: '48px',
    fontSize: pxToRem(40),
    ...responsiveFontSizes({ sm: 27 }),
  },
  h2: {
    fontWeight: 600,
    lineHeight: '36px',
    fontSize: pxToRem(32),
    ...responsiveFontSizes({ sm: 23 }),
  },
  h3: {
    fontWeight: 600,
    lineHeight: '24px',
    fontSize: pxToRem(20),
  },
  h4: {
    fontWeight: 600,
    lineHeight: '24px',
    fontSize: pxToRem(16),
  },
  h5: {
    fontWeight: 600,
    lineHeight: '24px',
    fontSize: pxToRem(13),
  },
  text1: {
    fontWeight: 400,
    lineHeight: '28px',
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 14 }),
  },
  text2: {
    fontWeight: 400,
    lineHeight: '16px',
    fontSize: pxToRem(14),
  },
  text3: {
    fontWeight: 400,
    lineHeight: '16px',
    fontSize: pxToRem(12),
  },
  text4: {
    fontWeight: 400,
    lineHeight: '12px',
    fontSize: pxToRem(10),
  },
} as const;
